export default {
  beforeMount(el, binding) {
    el.clickOutsideEvent = function (event) {
      if (
        !(el === event.target ||
          el.contains(event.target) ||
          (binding.value.except && binding.value.except.includes(event.target.id)))
      ) {
        binding.value.method(event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unmounted(el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  }
};
